import ArrowsArrowRightLLine from './arrows-arrow-right-l-line.component.js'

export * from './arrows-arrow-right-l-line.component.js'
export default ArrowsArrowRightLLine

ArrowsArrowRightLLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-arrow-right-l-line': ArrowsArrowRightLLine
  }
}
